import React, { useState } from 'react';
import { Modal, Button } from '../../ui-kit';
import UnderstaffingWarningTemplate from './UnderstaffingWarningTemplate';
import WorkingTimeDirectiveWarningTemplate from './WorkingTimeDirectiveWarningTemplate';
import ContractConstraintWarningTemplate from './ContractConstraintWarningTemplate';
import SaveButton from '../../general/SaveButton';

const GenericWarningTemplate = () => <div>Warning Template Implementation Missing</div>;

// To support new warning types, the template must be added to this hash
const WarningTemplates = {
  understaffing: UnderstaffingWarningTemplate,
  working_time_directive: WorkingTimeDirectiveWarningTemplate,
  contract_constraints: ContractConstraintWarningTemplate
};

// This renders the actual ScheduleWarningsPopover. For the Rails or React
// versions see ScheduleWarningsPopover and ScheduleWarningsPopoverConnected
// respectively
const ScheduleWarningsPopoverInner = ({ warnings, handleDismiss, handleConfirm }) => {
  const [processing, setProcessing] = useState(false);

  const handleConfirmWrapper = async () => {
    setProcessing(true);
    try {
      await handleConfirm();
    } finally {
      setProcessing(false);
    }
  };

  if (Object.keys(warnings).length === 0) return null;

  return (
    <Modal show={true} onHide={handleDismiss} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('groups.index.warnings')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(warnings).map(warningType => (
          <WarningsOfType key={warningType} type={warningType} warnings={warnings[warningType]} />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleDismiss} disabled={processing}>
          {I18n.t('cancel')}
        </Button>
        <SaveButton
          label={I18n.t('confirm')}
          style={'warning'}
          hasUnsavedChanges={true}
          isSaving={processing}
          onClick={handleConfirmWrapper}
        />
      </Modal.Footer>
    </Modal>
  );
};

const WarningsOfType = ({ type, warnings }) => {
  let WarningTemplate = WarningTemplates[type];
  // If the template is missing, render the generic one
  if (!WarningTemplate) WarningTemplate = GenericWarningTemplate;

  return (
    <>
      <h4>{I18n.t(`schedule_warnings.${type}.message`)}</h4>
      <WarningTemplate warnings={warnings} />
    </>
  );
};

export default ScheduleWarningsPopoverInner;
